import VacancyDeleteConfirmationModal from './VacancyDeleteConfirmationModal.component';

export default VacancyDeleteConfirmationModal;
